import { useMemo } from 'react';
import { CardWrapper, CardJpDetails, CardVenueDetails } from './worker-base-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function WorkerJpCard(_ref) {
  var restaurantLogo = _ref.restaurantLogo,
      restaurantName = _ref.restaurantName,
      publishedAt = _ref.publishedAt,
      city = _ref.city,
      redirectUrl = _ref.redirectUrl,
      newTab = _ref.newTab,
      occupation = _ref.occupation,
      salaryMin = _ref.salaryMin,
      salaryMax = _ref.salaryMax,
      salary = _ref.salary,
      jobType = _ref.jobType,
      jobTitle = _ref.jobTitle,
      onClick = _ref.onClick,
      wrapperStyle = _ref.wrapperStyle,
      isJobPositionOutsideItaly = _ref.isJobPositionOutsideItaly,
      hasAlreadyApplied = _ref.hasAlreadyApplied;
  var variant = 'jp';
  var badges = useMemo(function () {
    return [occupation || '', salaryMax && salaryMax ? "\u20AC".concat(salaryMin, "-").concat(salaryMax) : salary ? "\u20AC".concat(salary) : '', jobType || ''].filter(Boolean);
  }, [jobType, occupation, salary, salaryMax, salaryMin]);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    variant: variant,
    href: redirectUrl,
    newTab: newTab,
    onClick: onClick,
    wrapperStyle: wrapperStyle,
    children: [/*#__PURE__*/_jsx(CardJpDetails, {
      badges: badges,
      title: jobTitle
    }), /*#__PURE__*/_jsx(CardVenueDetails, {
      variant: variant,
      logoSrc: restaurantLogo,
      city: city,
      firstSubDate: publishedAt,
      venueName: restaurantName,
      isOutsideItaly: isJobPositionOutsideItaly,
      hasAlreadyApplied: hasAlreadyApplied
    })]
  });
}